import React from 'react';
import MultipleTabsModal from './MultipleTabsModal';

export default {
  title: 'Components/Modals/MultipleTabsModal',
  component: MultipleTabsModal,
  argTypes: {
    handleClose: { action: 'handleClose' },
    title: { control: 'text' },
  },
  tags: ['autodocs'],
};

// Default story
const Template = (args) => <MultipleTabsModal {...args} />;

export const DefaultMultipleTabsModal = Template.bind({});
DefaultMultipleTabsModal.args = {
  title: 'Multiple Tabs Modal',
  tabs: {
    tab1: {
      label: 'Tab 1',
      content: <div>Content for Tab 1</div>,
    },
    tab2: {
      label: 'Tab 2',
      content: <div>Content for Tab 2</div>,
    },
  },
};

export const SingleTab = Template.bind({});
SingleTab.args = {
  title: 'Single Tab Modal',
  tabs: {
    tab1: {
      label: 'Only Tab',
      content: <div>Content for the only tab</div>,
    },
  },
};
